import customerApi from '@/api/customer';
import { loadEntity, loadPaginatedEntity, enhanceOrAdd } from '@/helpers/utility';

const state = {
    byId: {},
    currentPage: null,
    totalPages: null,
    currentPageIds: null,

    mailingListOptions: {
        yes: 'Yes',
        no: 'No',
        already_subscribed: 'Already Subscribed',
    },
};

const getters = {
    currentPageCustomers(state) {
        if (state.currentPageIds)
            return state.currentPageIds.map(id => state.byId[id]);
    },
};

const actions = {
    async getCustomers({ commit }, { page, search, orderby }) {
        let pagedCustomers = await customerApi.list({ page, search, orderby });
        loadPaginatedEntity('customers', pagedCustomers);
    },
    async getCustomer(store, { id }) {
        let customer = await customerApi.get(id);
        loadEntity({ customer });
        return customer;
    },
    async searchCustomers({ commit }, { term }) {
        let customers = await customerApi.search(term);
        commit('LOAD_ENTITIES', { customers });
        return customers;
    },
    async createCustomer({ dispatch }, { customer }) {
        customer = await customerApi.create(customer);
        loadEntity({ customer });
        return customer;
    },
    async updateCustomer({ dispatch }, { customer }) {
        customer = await customerApi.update(customer);
        loadEntity({ customer });
        return customer;
    },
    async readCustomerMessages(store, { customer }) {
        customer = await customerApi.readMessages(customer);
        loadEntity({ customer });
        return customer;
    },
    async deleteCustomer({ commit }, { customer }) {
        let response = await customerApi.delete(customer);
        commit('REMOVE_CUSTOMER', { response });
        return response;
    },
};

const mutations = {
    LOAD_ENTITIES(state, { customers, meta }) {
        if (customers)
            Object.values(customers).forEach(customer => enhanceOrAdd(state.byId, customer.id, customer));

        if (meta && meta.type === 'customers' && meta.paginated) {
            state.currentPage = meta.currentPage;
            state.totalPages = meta.totalPages;
            state.currentPageIds = meta.ids;
        }
    },
    UPDATE_CUSTOMER(state, { customer }) {
        Vue.set(state.byId, customer.id, customer);
    },
    REMOVE_CUSTOMER(state, { response }) {
        Vue.delete(state.byId, response.id);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
